/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const CheckOutlineIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="20px"
      width="20px"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6068 6.12381L8.41247 14.3181L7.97053 14.7601L7.52858 14.3181L3.39325 10.1828L4.27713 9.29889L7.97053 12.9923L15.7229 5.23993L16.6068 6.12381Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
